import React from "react";
export default function SVGWrenchDoc() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 478.268 478.268"
    >
      <g fill="#000000">
        <path
          fill="#000000"
          d="M445.905,0H145.418c-8.781,0-15.902,7.121-15.902,15.902v237.204l31.804-31.804V31.804h268.683v373.849h-20.018v31.804   h35.92c8.781,0,15.902-7.121,15.902-15.902V15.902C461.807,7.121,454.686,0,445.905,0z"
        />
        <path
          fill="#000000"
          d="M134.353,432.922c2.866,2.788,6.755,4.535,11.065,4.535h181.501v-31.804H161.622L134.353,432.922z"
        />
        <path
          fill="#000000"
          d="M417.634,350.849c0-9.629-2.874-18.534-7.649-26.121c-3.16-5.016-7.213-9.341-11.919-12.921   c-8.253-6.273-18.442-10.141-29.615-10.141c-11.173,0-21.361,3.867-29.615,10.141c-4.705,3.58-8.759,7.905-11.919,12.921   c-4.775,7.587-7.649,16.492-7.649,26.121c0,9.621,2.874,18.534,7.649,26.113c4.03,6.397,9.465,11.725,15.902,15.684v80.863   c0,1.956,1.204,3.719,3.02,4.434c0.56,0.216,1.15,0.326,1.732,0.326c1.304,0,2.578-0.536,3.502-1.53l13.884-15.016   c0.9-0.972,2.166-1.522,3.494-1.522c1.328,0,2.594,0.55,3.494,1.522l13.884,15.016c0.924,0.994,2.198,1.53,3.502,1.53   c0.582,0,1.172-0.11,1.732-0.326c1.816-0.714,3.02-2.478,3.02-4.434v-80.863c6.437-3.96,11.873-9.287,15.902-15.684   C414.761,369.383,417.634,360.47,417.634,350.849z M368.452,329.364c11.865,0,21.485,9.621,21.485,21.485   c0,11.865-9.621,21.485-21.485,21.485c-11.865,0-21.485-9.621-21.485-21.485C346.967,338.985,356.587,329.364,368.452,329.364z"
        />
        <path
          fill="#000000"
          d="M327.991,245.187c21.99-1.174,42.231-12.346,54.942-30.338l13.372-18.938c11.537-16.32,9.627-38.568-4.503-52.692   c-1.71-1.716-3.961-2.57-6.197-2.57c-2.252,0-4.488,0.854-6.203,2.57l-34.84,34.826c-3.06,3.059-7.075,4.597-11.081,4.597   c-4.015,0-8.021-1.538-11.081-4.597L296.9,152.546c-2.951-2.936-4.597-6.927-4.597-11.081c0-4.162,1.646-8.137,4.589-11.089   l34.832-34.832c3.432-3.424,3.432-8.977,0-12.4c-7.943-7.951-18.456-12.027-29.033-12.027c-8.237,0-16.514,2.468-23.659,7.515   l-18.938,13.379c-17.99,12.711-29.157,32.946-30.337,54.944l-2.252,41.883L28.598,387.771c-16.182,16.18-16.182,42.403,0,58.583   c8.091,8.099,18.698,12.145,29.296,12.145s21.198-4.046,29.289-12.137l198.933-198.931L327.991,245.187z"
        />
      </g>
    </svg>
  );
}
